import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from 'src/components/editor/EditTracking';

const MultipleChoiceSurveyTracking: FC = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      background: none;

      .top_wrapper {
        justify-content: end;
      }

      .center_wrapper {
        padding: 0;
      }
      .survey button {
        background: none;
      }

      .btn_wrapper {
        width: 100%;
      }
      .btn_wrapper button {
        background: transparent;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view root_tracking">
        <div className="template">
          <div className="center_horizon top_wrapper">
            <EditTracking
              value={tracking?.close?.[currentIndex]}
              type="close"
            />
          </div>
          <div className="center_wrapper">
            <div>
              <div className="title" />
              <div className="sub_title" />
            </div>
            <div className="survey_wrapper">
              {btnText?.option_button?.[currentIndex]?.map(
                (_: string, idx: number) => (
                  <div key={idx} className="survey">
                    <button className="tracking_center">
                      <EditTracking
                        value={tracking?.option_button?.[currentIndex]?.[idx]}
                        type="option_button"
                        idx={idx}
                      />
                    </button>
                  </div>
                )
              )}
            </div>
          </div>
          <div className="btn_wrapper">
            <button className="tracking_center">
              <EditTracking
                value={tracking?.button?.[currentIndex]}
                type="button"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MultipleChoiceSurveyTracking;
